import React from 'react';
import { useLocalStorage } from 'hooks';
import { Button } from 'components/common/button';
import styled from 'styled-components';

const NormalSize = styled.span<{ value: number }>`
    font-size: ${props => 15 * props.value}px !important;
`;

const SizeSection: React.FC = () => {
    const [value, setValue] = useLocalStorage('size', '1');

    return (
        <>
            <Button style={{ paddingTop: 8, paddingBottom: 8 }} type="link" onClick={() => setValue('1')}>
                <NormalSize value={parseFloat(value)}>A</NormalSize>
            </Button>
            <Button style={{ paddingTop: 8, paddingBottom: 8 }} type="link" onClick={() => setValue('1.4')}>
                <NormalSize value={parseFloat(value)}>A+</NormalSize>
            </Button>
            <Button style={{ paddingTop: 8, paddingBottom: 8 }} type="link" onClick={() => setValue('1.6')}>
                <NormalSize value={parseFloat(value)}>A++</NormalSize>
            </Button>
        </>
    );
};

export default SizeSection;
